export class GcpRestoreServices {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gce",
            "baseName": "gce",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcs",
            "baseName": "gcs",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudsql",
            "baseName": "cloudsql",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bigquery",
            "baseName": "bigquery",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sapHana",
            "baseName": "sapHana",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreServices.attributeTypeMap;
    }
    constructor() {
    }
}
